import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {isMobile} from "react-device-detect"
//import {Helmet  } from 'react-helmet-async'
import {Links} from '../routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'

import {
  useScreenDetailsQuery, useScreenQuery, useFollowUnfollowScreen, useCheckScreenFollowStatus
} from '../data/screen-details';

import { Table } from "../components/ui/table";
//import Pagination from '../components/ui/pagination';
import { Pagination, Select } from "antd";
import { t } from "i18next";
import { amount_format } from "../components/config/Common";
import Breadcrumb  from "../components/Breadcrumb";
import CompanyTable  from "../components/CompanyTable";
import {APP_URL, APP_NAME} from 'components/config/Common'
//import { useLocation } from "react-router-dom";
import Seo from 'components/seo/seo'
import Button from 'components/ui/Button.tsx'

import LoginwithEmail from "components/auth/user/LoginwithEmail";
import SocialLogin from "components/auth/SocialLogin";
import ModalView from '_utils/ModalView'
import RelatedScreens from './related-screens/related-screens'


const ScreenDetails = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
	const {slug} = useParams()
  const [access_token,setAccess_token] = useState(localStorage.getItem('access_token'));
  const [isLogin, setIsLogin] = useState(false);

	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [metaTitle, setMetaTitle] = useState('')
	const [metaDesc, setMetaDesc] = useState('')
	const [user_type, setUser_type] = useState('');
  const [snipetData, setSnipetData] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
  const [orderBy, setOrder] = useState('created_at');
  const [sortedBy, setColumn] = useState('desc');
  const [open, setOpen] = useState(false);
  // SORTING
  const [sortInfo, setSortInfo] = useState({ key: null, order: null });
  const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
  const { pathname } = useLocation();

  useEffect(() => {              
      window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // change to "smooth" if you want animation
      });
  }, [pathname]);

  const openPopup = () => {
    setOpen(true);
  };

  useEffect(() => {
      if(access_token){
          setIsLogin(true)
      }
  }, [access_token]);

  const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }
  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }  
  
	//console.log("slug",slug);
	const {
		product,
    screenDetails,
    paginatorInfo,
		isLoading,
		error,
	} = useScreenDetailsQuery({ 
    slug,
    limit: pageSize,
    page,    
    orderBy,
    sortedBy,
	});

  //console.log("screenDetails",screenDetails);

  const { data: followStatus } = useCheckScreenFollowStatus(screenDetails?.id);

  //console.log("followStatus",followStatus);
  
  useEffect(() => {
    setMetaTitle(screenDetails?.meta_title ? screenDetails?.meta_title : screenDetails?.title);
    setMetaDesc(screenDetails?.meta_description ? screenDetails?.meta_description : screenDetails?.description);
  
  }, [screenDetails]);

	//console.log("product",product);
  const { mutate: followUnfollowScreen } = useFollowUnfollowScreen(screenDetails?.id);
  const follow_unfollow_screen = (screen_id, action) => {
    if (!isLogin) {
        openPopup();   // login modal
        return;
      }
    //console.log("screen_id",screen_id);
    followUnfollowScreen({ screen_id, action }, {
      onSuccess: (data) => {
        //console.log("followUnfollowScreen data",data);
        // Reload screen details to reflect follow status
        //queryClient.invalidateQueries({ queryKey: ["screen-details", { slug }] });
      },
    });
  }
  

const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Screens`,
    link:`${process.env.REACT_APP_URL}${Links.SCREENS}`
  },
  {
    name:`${screenDetails?.title}`,
    link:null
  },
]

	return (
		<>
    <Seo 
        title={`${metaTitle} - ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/screens/${slug}`}
      />
		<Header  />        
        <div className="space-y-5 px-5 lg:px-8">
          {screenDetails && <Breadcrumb breadcrumb={breadcrumb} />}
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl">{screenDetails?.title}</h2>
                  {followStatus && followStatus.is_following ? (
                    <Button size="small" onClick={() => follow_unfollow_screen(screenDetails?.id, 'unfollow')}>Unfollow</Button>
                  ) : (
                  <Button size="small" onClick={() => follow_unfollow_screen(screenDetails?.id,'follow')}>Follow</Button>
                  )}
                </div>
                
                <div className="mt-4 prose max-w-full" dangerouslySetInnerHTML={{__html: screenDetails?.description || ''}}></div>
                {screenDetails?.user?.name && <div className="mt-3 text-accent">By {screenDetails?.user?.name}</div>}
                
                <CompanyTable 
                    data={product} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    totalPages={totalPages}
                    onPagination={onPagination}
                    onPageSize={onPageSize}
                />
                
                <div>
                  <div>Search Query</div>
                  <pre className="bg-gray-100 p-5 rounded mt-2 overflow-x-auto">
                    <code>
                      {screenDetails?.userQuery }
                    </code>
                  </pre>
                </div>
            </section>
            <RelatedScreens />
        </div>
       <ModalView open={open} onClose={() => setOpen(false)}>
                     <div className="flex flex-col justify-center">
                         <div className="text-center text-base text-body">Don't have an account? <Link to={`${Links.USER_SIGNUP}`} className="text-accent underline transition-colors duration-200 hover:text-accent-hover hover:no-underline focus:text-accent-hover focus:no-underline focus:outline-none ltr:ml-1 rtl:mr-1">Create New</Link></div>
                         
                       </div>  
                     <LoginwithEmail goTo={window.location.href} />
                     <SocialLogin mode='Login' user_type='user' goTo={window.location.href} />
                   </ModalView>
		<Footer />
		
		
		</>
		);
};

export default ScreenDetails;